import React, { useEffect, useState } from "react";
import "./ImageModal.css";

// images 
import closeIcon from "../../assets/images/close-icon.svg";
import zoomInIcon from "../../assets/images/zoomIn.svg";
import zoomOutIcon from "../../assets/images/zoomOut.svg";
import downloadIcon from "../../assets/images/downloadIcon.svg";

export const ImageModal = ({
  image,
  onClose,
  showZoomInZoomOut = false,
  showDownload = false
}) => {
  const [zoomLevel, setZoomLevel] = useState(1);

  // Extract url and filename from image object or string
  const imageUrl = typeof image === 'string' ? image : image?.url;
  const filename = typeof image === 'string' ? `image-${Date.now()}.jpg` : (image?.filename || `image-${Date.now()}.jpg`);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    // Reset zoom when image changes
    setZoomLevel(1);
  }, [imageUrl]);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("image-modal-backdrop")) {
      onClose();
    }
  };

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.25, 3)); // Max zoom 3x
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.25, 0.5)); // Min zoom 0.5x
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="image-modal-backdrop" onClick={handleBackdropClick}>
      <div className="image-modal-header">
        {showDownload && (
          <button
            className="image-modal-header-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleDownload();
            }}
            title="Download"
          >
            <img src={downloadIcon} alt="download" />
          </button>
        )}
        <button
          className="image-modal-header-btn"
          onClick={onClose}
          title="Close"
        >
          <img src={closeIcon} alt="close" />
        </button>
      </div>

      <div className="image-modal-content">
        <div className="image-modal-image-wrapper">
          <img
            src={imageUrl}
            alt="Preview"
            className="image-modal-img"
            style={{ transform: `scale(${zoomLevel})` }}
          />
          {showZoomInZoomOut && (
            <div className="image-modal-controls">
              <button
                className="image-modal-control-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleZoomIn();
                }}
                title="Zoom In"
              >
                <img src={zoomInIcon} alt="zoom in" />
              </button>
              <button
                className="image-modal-control-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleZoomOut();
                }}
                title="Zoom Out"
              >
                <img src={zoomOutIcon} alt="zoom out" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
